import Vue from 'vue'
import md5 from 'md5'
import appConfig from '@/common/appConfig'
const vm = new Vue()
const common = {
  namespaced: true,
  state: {
    appInit: false,
    startInfo: null,
    appStartTime: new Date().getTime(),
    referer: '启动', // 来源页面
    currentPage: '', // 当前页面
    currentVideoId: null, //当前短剧id
    firstCanplaythrough: true, //是否需要上报首个视频加载时长埋点
  },
  mutations: {
    COMPLETE_APP_INIT(state){
      state.appInit = true
    },
    SET_START_INFO(state, info) {
      state.startInfo = info
    },
    SET_REFERER: (state, data) => {
      console.log('设置referer', data)
      state.referer = data ? data : '启动'
    },
    SET_CURRENTPAGE: (state, data) => {
      console.log('设置当前页', data)
      state.currentPage = data
    },
    SET_CURRENTVIDEOID: (state, data) => {
      state.currentVideoId = data
    },
    REPORTED_FIRST_VIDEO:(state)=>{
      state.firstCanplaythrough = false
    }
  },
  actions: {
    async initSDK({
      rootState,
      state,
      commit,
      dispatch
    }) {
      const UserId = String(vm.$utils.get(rootState.user.userInfo, 'open_id'))
      const mdDeviceId = md5(UserId)
      let arrNum = mdDeviceId.slice(mdDeviceId.length - 1)
      // AB_SDK.re_set_header('Utm-Source', curUtmSource)

      REPORT_SDK.set_attr('ext_field_3', String(parseInt(arrNum, 16) % 8)) // 流量分组
      REPORT_SDK.set_attr('ext_field_5', vm.$utils.getUtmRightValue(state.startInfo.query, 'video_id', ''))
      const query = vm.$utils.get(state.startInfo, 'query')
      const qd_id = vm.$utils.getUtmRightValue(rootState.user.userInfo, 'tx_monitor_info.channelId', '-1')
      const open_id = String(vm.$utils.get(rootState.user.userInfo, 'wx_open_id'))
      const utmSource = vm.$utils.getUtmRightValue(rootState.user.userInfo, 'tx_monitor_info.utmSource', '-1')
      const advertiser_id =  vm.$utils.getUtmRightValue(rootState.user.userInfo, 'tx_monitor_info.advertiser_id', '-1')
      REPORT_SDK.set_attr('ext_field_10', `unionid=${ UserId}&&appid=${appConfig.currentApp.appid}&&openid=${open_id}&&advertiser_id=${advertiser_id}`)
      await REPORT_SDK.sdk_init({
        qd_id, // 渠道id
        link_id: vm.$utils.getUtmRightValue(rootState.user.userInfo, 'tx_monitor_info.linkId', '-1'), // 链接id
        menu_bar: 0, // 是否有胶囊
        open_id: UserId,
        mode_state: 2, // 是否审核模式
        source_pkg: appConfig.pkgName,
        newer_state: vm.$utils.get(rootState.user.userInfo, 'is_new') ? 1 : 0, // 是否新用户
        login_state: vm.$utils.get(rootState.user.userInfo, 'headImg') ? true : false, // 登录状态
        pay_state: vm.$utils.get(rootState.user.userInfo, 'has_pay') ? 1 : 0, // 是否付费
        utm_ad_id: vm.$utils.getUtmRightValue(rootState.user.userInfo, 'tx_monitor_info.utmAdId', '-1'), // 活动、广告id
        utm_campaign: vm.$utils.getUtmRightValue(rootState.user.userInfo, 'tx_monitor_info.utmCampaign', '-1'), // 活动、广告名称
        utm_content: vm.$utils.getUtmRightValue(rootState.user.userInfo, 'tx_monitor_info.utmContent', '-1'), // 活动、广告内容
        utm_medium: vm.$utils.getUtmRightValue(rootState.user.userInfo, 'tx_monitor_info.utmMedium', '-1'), // 活动、广告媒介
        utm_source: vm.$utils.getUtmRightValue(rootState.user.userInfo, 'tx_monitor_info.utmSource', '-1'), // 活动、广告来源
        utm_term: vm.$utils.getUtmRightValue(rootState.user.userInfo, 'tx_monitor_info.utmTerm', '-1') // 活动、广告关键字
      })

      REPORT_SDK.report({
        event_name: '启动',
        event_id: 'hap',
        result: query ? JSON.stringify(query) : '',
        page_url: vm.$utils.get(query, 'video_id', '-1'),
      })
      commit('COMPLETE_APP_INIT')
    }
  }
}
export default common
